import component from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-confirmation/lni-retaliation-confirmation.component.vue';
import module from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-confirmation/lni-retaliation-confirmation.module.js';

export default {
    component,
    module,
};